import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TaskResultGeneric} from '../../models/task-result-generic';
import {PagedResult} from '../../models/paged-result.model';
import {buildQueryString} from '../query-bulider.service';
import {AppConfig} from '../config.service';
import { TaskResult } from '../../models/client-models';
import {BalanceBookingModel, PersonAndDay} from '../../models/client-models';
import {BalanceBookingQueryExt} from '../../models/balance-booking/balance-booking-query.model';

const BALANCEBOOKING_ENDPOINT = 'balanceBooking';

@Injectable({
  providedIn: 'root',
})
export class BalanceBookingBackendService {
  constructor(private http: HttpClient) {}

  public getListAsync(
    query: BalanceBookingQueryExt
  ): Observable<TaskResultGeneric<PagedResult<BalanceBookingModel>>> {
    const queryString = buildQueryString(query);
    return this.http.get<TaskResultGeneric<PagedResult<BalanceBookingModel>>>(
      AppConfig.settings.backend.url + BALANCEBOOKING_ENDPOINT + queryString
    );
  }

  public authorizeExceptionForBreakViolation(
    data: PersonAndDay
  ): Observable<TaskResult> {
    return this.http.post<TaskResultGeneric<PagedResult<BalanceBookingModel>>>(
      AppConfig.settings.backend.url +
        BALANCEBOOKING_ENDPOINT +
        '/AuthorizeExceptionForBreakViolation',
      data
    );
  }

  public deleteAuthorizeExceptionForBreakViolation(
    data: PersonAndDay
  ): Observable<TaskResult> {
    return this.http.delete<
      TaskResultGeneric<PagedResult<BalanceBookingModel>>
    >(
      AppConfig.settings.backend.url +
        BALANCEBOOKING_ENDPOINT +
        '/AuthorizeExceptionForBreakViolation?personID=' +
        data.personID +
        '&date=' +
        data.date
    );
  }
}
